<template>
    <div class="c-rate">
        <span
            v-for="item in max"
            :key="item"
        >
            <i
                :class="[classes[item - 1]]"
                class="c-rate__icon iconfont"
                :style="getIconStyle(item)"
            >
                <i
                    v-if="showDecimalIcon(item)"
                    :class="decimalIconClass"
                    :style="decimalStyle"
                    class="c-rate__decimal"
                >
                </i>
            </i>
        </span>
        <span v-if="showText" class="c-rate__text rate-text" :style="{ color: textColor }">{{ text }}</span>
    </div>
</template>
<script>
    export default {
        props: {
            value: {
                type: [Number, String],
                default: 0
            },
            lowThreshold: {
                type: Number,
                default: 2
            },
            highThreshold: {
                type: Number,
                default: 4
            },
            max: {
                type: Number,
                default: 5
            },
            colors: {
                type: Array,
                default() {
                    return ['#FFFFFF', '#FFFFFF ', '#FFFFFF'];
                }
            },
            voidColor: {
                type: String,
                default: '#FFFFFF'
            },
            disabledVoidColor: {
                type: String,
                default: '#FFFFFF'
            },
            iconClasses: {
                type: Array,
                default() {
                    return ['el-icon-star', 'el-icon-star', 'el-icon-star'];
                }
            },
            voidIconClass: {
                type: String,
                default: 'el-icon-star-off'
            },
            disabledVoidIconClass: {
                type: String,
                default: 'el-icon-star'
            },
            disabled: {
                type: Boolean,
                default: false
            },
            allowHalf: {
                type: Boolean,
                default: true
            },
            showText: {
                type: Boolean,
                default: false
            },
            text: {
                type: String,
                default: ''
            },
            textColor: {
                type: String,
                default: '#555'
            },
            textTemplate: {
                type: String,
                default: '{value}'
            }
        },

        data() {
            return {
                classMap: {},
                pointerAtLeftHalf: true,
                currentValue: this.value,
                hoverIndex: -1
            };
        },

        computed: {
            decimalStyle() {
                let width = '';
                if (this.disabled) {
                    width = `${this.valueDecimal}%`;
                }
                if (this.allowHalf) {
                    width = `${this.valueDecimal}%`;
                    // width = '50%';
                }
                return {
                    color: this.activeColor,
                    width
                };
            },

            valueDecimal() {
                return this.value * 100 - Math.floor(this.value) * 100;
            },

            decimalIconClass() {
                return this.getValueFromMap(this.value, this.classMap);
            },

            voidClass() {
                return this.disabled ? this.classMap.disabledVoidClass : this.classMap.voidClass;
            },

            activeClass() {
                return this.getValueFromMap(this.currentValue, this.classMap);
            },

            colorMap() {
                return {
                    lowColor: this.colors[0],
                    mediumColor: this.colors[1],
                    highColor: this.colors[2],
                    voidColor: this.voidColor,
                    disabledVoidColor: this.disabledVoidColor
                };
            },

            activeColor() {
                return this.getValueFromMap(this.currentValue, this.colorMap);
            },

            classes() {
                const result = [];
                let i = 0;
                let threshold = this.currentValue;
                if (this.allowHalf && this.currentValue !== Math.floor(this.currentValue)) {
                    threshold--;
                }
                for (; i < threshold; i++) {
                    result.push(this.activeClass);
                }
                for (; i < this.max; i++) {
                    result.push(this.voidClass);
                }
                return result;
            }
        },

        watch: {
            value(val) {
                this.$emit('change', val);
                this.currentValue = val;
                this.pointerAtLeftHalf = this.value !== Math.floor(this.value);
            }
        },

        created() { 
            if (!this.value) {
                this.$emit('input', 0);
            }
            this.classMap = {
                lowClass: this.iconClasses[0],
                mediumClass: this.iconClasses[1],
                highClass: this.iconClasses[2],
                voidClass: this.voidIconClass,
                disabledVoidClass: this.disabledVoidIconClass
            };
        },

        methods: {
            getValueFromMap(value, map) {
                let result = '';
                if (value <= this.lowThreshold) {
                    result = map.lowColor || map.lowClass;
                } else if (value >= this.highThreshold) {
                    result = map.highColor || map.highClass;
                } else {
                    result = map.mediumColor || map.mediumClass;
                }
                return result;
            },

            showDecimalIcon(item) {
                const showWhenDisabled = this.disabled && this.valueDecimal > 0 && item - 1 < this.value && item > this.value;
                /* istanbul ignore next */
                const showWhenAllowHalf = this.allowHalf
                    && this.pointerAtLeftHalf
                    && item - 0.5 <= this.currentValue
                    && item > this.currentValue;
                return showWhenDisabled || showWhenAllowHalf;
            },

            getIconStyle(item) {
                const voidColor = this.disabled ? this.colorMap.disabledVoidColor : this.colorMap.voidColor;
                return {
                    color: item <= this.currentValue ? this.activeColor : voidColor
                };
            }
        }
    }
</script>
<style scoped lang="scss">
    @import "~@/common/style/mixin/iconfont";
    @import "~@/common/style/mixin/utils";

    .c-rate {
        display:flex;
        display: -webkit-flex;
        align-items: center;
        -webkit-align-items: center;
        span{
            display:flex;
            display:-webkit-flex;
            flex:1;
        }
        .c-rate__icon {
            // min-width: 1em;
            margin-right: px2rem(3);
            font-size: px2rem(10);
            position: relative;
            .c-rate__decimal {
                position: absolute;
                top: 0;
                left: 0;
                display: inline-block;
                overflow: hidden;
                font-style: normal;
            }
        }
        span:last-child{
            .c-rate__icon{
                margin-right: 0;
            }
        }
        .rate-text {
            margin-left: 5px;
            font-size: px2rem(12);
        }
    }
</style>
